import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { useT } from "@/contexts/LanguageContext";

export default function Footer() {
  const t = useT();

  return (
    <footer data-testid="main-footer" className="bg-[#0A0A0A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="mb-4">
              <img src="/logo.png" alt="AtoB Logistic Solutions GmbH" className="h-14 w-auto brightness-0 invert" />
            </div>
            <p className="text-sm text-gray-400 leading-relaxed max-w-xs">
              {t("footer_desc")}
            </p>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#FFD700] mb-4">{t("footer_nav")}</h4>
            <div className="space-y-2">
              <Link to="/" className="block text-sm text-gray-400 hover:text-white transition-colors">{t("nav_home")}</Link>
              <a href="/#leistungen" className="block text-sm text-gray-400 hover:text-white transition-colors">{t("nav_services")}</a>
              <a href="/#kontakt" className="block text-sm text-gray-400 hover:text-white transition-colors">{t("nav_contact")}</a>
            </div>
          </div>

          <div>
            <h4 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#FFD700] mb-4">{t("footer_contact")}</h4>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="w-4 h-4 text-[#FFD700] mt-0.5 shrink-0" />
                <span className="text-sm text-gray-400">Schneiderstr. 63, 40764 Langenfeld (Rheinland)</span>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="w-4 h-4 text-[#FFD700] shrink-0" />
                <a href="mailto:info@atob-logistics.de" className="text-sm text-gray-400 hover:text-white transition-colors">info@atob-logistics.de</a>
              </div>
              <div className="flex items-center gap-3">
                <Phone className="w-4 h-4 text-[#FFD700] shrink-0" />
                <a href="tel:+4921732046451" className="text-sm text-gray-400 hover:text-white transition-colors">+49 2173 2046451</a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-gray-500">&copy; {new Date().getFullYear()} AtoB Logistic Solutions GmbH. {t("footer_rights")}</p>
          <div className="flex gap-6">
            <Link to="/impressum" className="text-xs text-gray-500 hover:text-gray-300 transition-colors">{t("footer_impressum")}</Link>
            <Link to="/datenschutz" className="text-xs text-gray-500 hover:text-gray-300 transition-colors">{t("footer_datenschutz")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
